export default __webpack_public_path__ + "static/media/avalanche-logo.9ee5db94.svg";